module.exports = __webpack_public_path__ + "static/media/3.0d43ab33.png";